import React from "react";

import { Formik, Form } from "formik";

import { Button, Typography, Modal } from "clearsense-ui/components";
import { Input } from "clearsense-ui/components/formik";

import { dashboardValidationSchema } from "../../validations";

const CreateViewModal = ({
  showCreateViewModal,
  isFetching,
  setShowCreateViewModal,
  onExecuteButtonClick,
}) => (
  <Formik
    enableReinitialize
    initialValues={{ title: "" }}
    validationSchema={dashboardValidationSchema}
    onSubmit={values =>
      onExecuteButtonClick(`CREATE MATERIALIZED VIEW ${values.title} AS `)
    }
  >
    {formik => (
      <Form>
        <Modal
          isOpen={showCreateViewModal}
          closeButton={false}
          data-cy="sql-editor-create-view-modal"
        >
          <Modal.Body>
            <Typography
              style="h3"
              className="my-6 font-semibold"
              data-cy="sql-editor-create-view-modal-header"
            >
              Create New View
            </Typography>
            <Input label="Title*" name="title" size="large" />
          </Modal.Body>
          <Modal.Footer className="space-x-2">
            <Button
              label="Create"
              size="large"
              type="submit"
              iconPosition="right"
              loading={isFetching}
              disabled={isFetching}
              onClick={formik.submitForm}
              data-cy="sql-editor-view-create-button"
            />
            <Button
              label="Cancel"
              style="text"
              size="large"
              onClick={() => {
                setShowCreateViewModal(false);
                formik.resetForm();
              }}
              data-cy="sql-editor-create-view-cancel-button"
            />
          </Modal.Footer>
        </Modal>
      </Form>
    )}
  </Formik>
);

export default CreateViewModal;
